// import packages
import React from 'react'
import PropTypes from 'prop-types';
import { Nav } from 'reactstrap';
import {Helmet} from 'react-helmet';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

// import utils
import {throttle} from '../../utils/index';
import { theme } from '../../style/theme';

//import components
import {Menu} from './Menu';

//import styled
import {
	StyledImage,
	StyledContainer,
	StyledNav,
	StyledHamburger,
	StyledHamburgerBox,
	StyledHamburgerInner,
	StyledLink,
	StyledList,
	StyledListItem,
	StyledListLink,
	StyledResumeButton,
	StyledLogo
} from './Nav_styled';

//import assets
import Logo from '../../assets/img/logo.png';
import cv from '../../assets/cv_tiavina.pdf';

const {  loaderDelay } = theme;

 export default class Navs extends React.Component {

	state = {
		menuOpen : false,
		scrollDirection: 'none',
		isMounted: !this.props.isHome
	};

	componentDidMount(){
		setTimeout(
			() =>
				this.setState( () => {
					window.addEventListener('resize', () => throttle(this.handleResize()));	
				}),
			100,
		);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', () => this.handleResize());
	}

	toggleMenu = () => this.setState({ menuOpen : !this.state.menuOpen });
	handleResize = () => {
		if (window.innerWidth > 768 && this.state.menuOpen) {
			this.toggleMenu();
		}
	};

	render(){
		const { menuOpen, scrollDirection,isMounted}  =this.state;
		const { isHome } = this.props;
		const timeout = isHome ? loaderDelay : 0;
		const fadeClass = isHome ? 'fade' : '';
		const fadeDownClass = isHome ? 'fadedown' : '';
		return(
      
      <>
      
			<StyledContainer scrollDirection={scrollDirection}>
				<Helmet>
					<body className={menuOpen ? 'blur' : ''} />
					<style>{'body { background-color: #0A192F; }'}</style>
				</Helmet>
				<StyledNav>

          <TransitionGroup component={null}>
            {isMounted && (
              <CSSTransition classNames={fadeClass} timeout={timeout}>
                <StyledLogo tabindex="-1">
                  <StyledImage src={Logo}/>
                </StyledLogo>
              </CSSTransition>
            )}
          </TransitionGroup>

					<TransitionGroup component={null}>
						{isMounted && (
							<CSSTransition classNames={fadeClass} timeout={timeout}>
								<StyledHamburger onClick={this.toggleMenu}>
									<StyledHamburgerBox>
										<StyledHamburgerInner menuOpen={menuOpen} />
									</StyledHamburgerBox>
								</StyledHamburger>
							</CSSTransition>
						)}
					</TransitionGroup>

					<StyledLink>
						<StyledList>
							{isMounted && (

							<TransitionGroup component={null}>

								<CSSTransition classNames={fadeClass} timeout={timeout}>
									<StyledListItem>
										<StyledListLink to="/home"> Accueil</StyledListLink>
									</StyledListItem>
								</CSSTransition>

								<CSSTransition classNames={fadeClass} timeout={timeout}>
									<StyledListItem>
										<StyledListLink to="/skills"> Competences</StyledListLink>
									</StyledListItem>
								</CSSTransition>

								<CSSTransition classNames={fadeClass} timeout={timeout}>
									<StyledListItem>
										<StyledListLink to="/projects"> Mes projets</StyledListLink>
									</StyledListItem>
								</CSSTransition>

								<CSSTransition classNames={fadeClass} timeout={timeout}>
									<StyledListItem>
										<StyledListLink to="/about"> A propos</StyledListLink>
									</StyledListItem>
								</CSSTransition>
								
							</TransitionGroup>
							)}
						</StyledList>

						<TransitionGroup component={null}>
							{isMounted && (
								<CSSTransition classNames={fadeDownClass} timeout={timeout}>
									
										<StyledResumeButton
											href={cv}
											target="_blank"
											rel="nofollow noopener noreferrer"
                      						download>
											Télécharger CV
                    				</StyledResumeButton>
									
								</CSSTransition>
							)}
						</TransitionGroup>
					</StyledLink>
				</StyledNav>
				<Menu menuOpen={menuOpen} toggleMenu={this.toggleMenu} />
			</StyledContainer>          
    </>        
      
			);
	}
	
}

Nav.propTypes = {
	isHome: PropTypes.bool,
};

